import { PageContent } from '@core/ui';
import { TableProvider } from '@core/table';

import { PostDeclarationTable, PostDeclarationsActionBar } from '../containers';
import { PostDeclarationTableContext } from '../context';
import { usePostDeclarationTableContext } from '../hooks';

export const PostDeclarationsPage = () => {
  const { handleFetch, defaultState } = usePostDeclarationTableContext();

  return (
    <TableProvider name='post-declarations' context={PostDeclarationTableContext} defaultState={defaultState} onFetch={handleFetch}>
      <PageContent $contain>
        <PostDeclarationsActionBar />
        <PostDeclarationTable />
      </PageContent>
    </TableProvider>
  );
};
